import { ReactNode } from 'react';

import { OrderReviewPreview } from '../../OrderReview';

export interface SuccessMessageProps {
  title: string;
  body: string;
  action: ReactNode;
  images: {
    id: string;
    src: string;
    alt: string;
  }[];
}

export const SuccessMessage = ({
  action,
  body,
  images,
  title,
}: SuccessMessageProps) => {
  return (
    <div className="flex flex-col gap-12">
      <h2 className="text-center text-md font-bold text-neutral-6 md:text-lg">
        {title}
      </h2>

      <span className="text-center">{body}</span>

      {action}

      <OrderReviewPreview images={images} />
    </div>
  );
};
